import Vue from 'vue';
import Router from 'vue-router';
import LandingLayout from '@/components/layouts/LandingLayout';
import Integrations from '@/components/views/landing/Integrations'


Vue.use(Router);

export const integrationsRoute = new Router({
  linkActiveClass: 'active',
  routes:[
    {
      path: '/',
      name: 'IntegrationsRoute',
      component: Integrations,
      meta: {
        requiresAuth: false,
        layout: LandingLayout
      }
    }
  ],
  mode: 'history'
})

export default integrationsRoute
